module.exports = __webpack_public_path__ + "media/bootstrap-icons/scissors-e35ebeb4.svg";